export default __webpack_public_path__ + "static/cashflow9-98ee7288f1c2cbdfef7514a33c4c6ccf.jpg";